'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackingBar = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _videoIndex = require('program/video-index.json');

var _videoIndex2 = _interopRequireDefault(_videoIndex);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TrackingBar = _react2['default'].createClass({

  displayName: "TrackingBar",

  mixins: [_reactAddonsPureRenderMixin2['default']],

  render: function render() {
    var _props = this.props,
        style = _props.style,
        videoId = _props.videoId,
        tracking = _props.tracking;


    var info = _videoIndex2['default'].meta[videoId];
    var len = info && info.duration || 1;

    return _react2['default'].createElement(
      'div',
      { style: style },
      tracking.map(function (_ref, idx) {
        var _ref2 = (0, _slicedToArray3['default'])(_ref, 2),
            start = _ref2[0],
            end = _ref2[1];

        return _react2['default'].createElement('div', {

          key: idx,

          style: {
            position: "absolute",
            backgroundColor: "green",
            left: 100 / len * start + "%",
            width: 100 / len * (end - start) + "%",
            top: 0,
            bottom: 0
          }

        });
      })
    );
  }
});

exports.TrackingBar = TrackingBar = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    tracking: state.tracking.seenVideos[ownProps.videoId] || []
  };
})(TrackingBar);

exports.TrackingBar = TrackingBar;


//////////////////
// WEBPACK FOOTER
// ./program/frontend/components/tracking-bar/index.jsx
// module id = 970
// module chunks = 0